import { defineComponent as _defineComponent } from 'vue'
import { useTab } from '@/composables/useTabs';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'UiTab',
  props: {
  name: {
    type: String,
    required: true,
  },
  text: {
    type: String,
    default: '',
  },
  link: {
    type: [String, Object],
    default: '',
  },
},
  setup(__props) {

const props = __props;


const tab = computed(() => ({
  name: props.name,
  text: props.text || props.name,
  link: props.link,
}));

const { isActive } = useTab(tab as any);

return { __sfc: true,props, tab, isActive }
}

})